import { useEffect, useCallback, useState, useRef } from 'react';
import styles from './index.module.scss';
import { useUserVipInfo } from '../../hooks/dataHooks';
import { LoadingOverlay } from '@mantine/core';
import { useVipState, updateVipState } from '@shakkerai/pro-store';
import { notifyError } from '@shakkerai/pro-components';
import { createPortal } from 'react-dom';

export const MESSAGE_PAY_TYPE = 'requestPurchase';

/**
 * 用于shakker内部的购买弹窗，弹窗负责被shakker项目内部业务使用
 * 2025年01月07日起要逐步替换为iframe的接入形式
 * @param {*} props
 */
export const PurchaseShakkerModal = () => {
  const proPurchaseModalVisible = useVipState('proPurchaseModalVisible');

  const { loadVipInfo } = useUserVipInfo();

  const closeModal = useCallback(() => {
    updateVipState({
      proPurchaseModalVisible: false,
    });
  }, []);

  const onPurchaseFinish = useCallback(() => {
    closeModal();

    // 刷新用户会员状态
    loadVipInfo();
    // eslint-disable-next-line
  }, [closeModal, loadVipInfo]);

  return (
    <PurchaseShakkerModalIFrame
      purchaseModalOpened={proPurchaseModalVisible}
      closePurchaseModal={closeModal}
      onPurchaseFinish={onPurchaseFinish}
    />
  );
};

/**
 * 会员弹窗的iframe形式，准备被替换
 * @returns
 */
const PurchaseShakkerModalIFrame = (props) => {
  const { purchaseModalOpened: shakkerVipModalVisible, closePurchaseModal, onPurchaseFinish } = props;

  const currentErrorCode = useVipState('currentErrorCode');
  const failurePrompt = useVipState('currentErrorMsg');

  const isVipModelCase = currentErrorCode === 1200000146;

  const stuationDesc = isVipModelCase
    ? 'You are using Membership Exclusive Models, upgrade to unlock access to all models!'
    : failurePrompt ||
      "You've run out of fast tokens, upgrade to unlock additional fast tokens, premium features, and much more!";

  /**
   * 控制是否iframe已经完成了渲染
   */
  const [frameLoadFinished, setFrameLoadFinished] = useState(false);

  const timeoutHandler = useRef();

  const vipIframe = useRef(null);

  useEffect(() => {
    if (shakkerVipModalVisible) {
      // 设置超时关闭
      timeoutHandler.current = setTimeout(() => {
        closePurchaseModal();
        notifyError(`loading resource timeout.`);
      }, 8000);

      const messageListener = async (event) => {
        try {
          if (!event.data) return;
          const parseResult = typeof event.data === 'object' ? event.data : JSON.parse(event.data);
          if (parseResult.type === 'onPurchasesClose') {
            closePurchaseModal();
            setFrameLoadFinished(false);
          } else if (parseResult.type === 'onPurchasesFinish') {
            closePurchaseModal();
            setFrameLoadFinished(false);
            onPurchaseFinish();
          } else if (parseResult.type === 'onLoadPageFinished') {
            setFrameLoadFinished(true);
            if (vipIframe.current) {
              // 发送弹窗的弹出原因
              vipIframe.current.contentWindow?.postMessage(
                JSON.stringify({
                  type: 'purchaseError',
                  data: stuationDesc,
                }),
                '*',
              );
            }

            // 取消超时动作
            if (timeoutHandler.current) {
              clearTimeout(timeoutHandler.current);
            }
          } else if (parseResult.type === 'redirect') {
            // stripe不能在iframe中被重定向，因此使外层容器进行重定向
            window.location.href = parseResult.data;
          }
        } catch (error) {
          // 正常情况下忽略错误
        }
      };

      window.addEventListener('message', messageListener);

      return () => {
        window.removeEventListener('message', messageListener);
      };
    }
  }, [shakkerVipModalVisible]);

  const resourceUrl = false ? 'https://www.shakker.ai/purchaseModal' : '/purchaseModal';

  console.info(`Shakker会员付费弹窗 shakkerVipModalVisible`, shakkerVipModalVisible);

  return (
    <div>
      {shakkerVipModalVisible &&
        createPortal(
          <div className="fixed top-0 left-0 right-0 bottom-0 z-[100] h-[100vh] w-[100vw] bg-black/60 flex items-center justify-center">
            <LoadingOverlay visible={!frameLoadFinished} zIndex={1000} overlayBlur={2} />

            <iframe
              src={resourceUrl}
              onError={() => {
                closePurchaseModal();
              }}
              ref={vipIframe}
              className={`w-[728px] max-h-[785px] h-[100%] ${frameLoadFinished ? '!block' : '!hidden'} ${styles.root}`}
            />
          </div>,
          document.body,
        )}
    </div>
  );
};
